<div class="ticket-wrapper">
  <div class="left-container">
    <div class="ticket-information-top">
      <div class="l1-title">
        Ticket information
      </div>
      <div
        *ngIf="ticket.ticketInfo.status !== 'new' && ticket.ticketInfo.ticketNo.substring(0, 1) !== 'D' && !isAdminViewerRole"
        class="gcic-sync-btn-container">
        <button (click)="syncTicket(ticket.ticketInfo.ticketNo)" class="btn btn-primary" type="button">
          <font-awesome [color]="'text-white'" [icon]="'fa-regular fa-arrows-rotate'" class="pr-8px"></font-awesome>
          Refresh Ticket Information (Synced {{ ticket.ticketInfo.sync | dkTimeAgo }})
        </button>
      </div>
    </div>
    <perfect-scrollbar #perfectScroll [style.padding-right]="'20px'">
      <ng-container *ngFor="let step of steps; let i = index">
        <app-contents-template *ngIf="isEditable(i)" [data]="steps[i]"></app-contents-template>
      </ng-container>

      <div class="d-flex flex-column">
        <div class="l2-title">Inquiry</div>
        <textarea [(ngModel)]="inquiry"
                  [disabled]="ticket.ticketInfo.status !== 'new'"
                  [ngClass]="{
                  'inquiry-disabled': ticket.ticketInfo.status !== 'new' && [companies.Seca].includes(company),
                  'mb-24px': true
                }"
                  aria-multiline="true"
                  class="mb-24px inquiry-disabled"
                  placeholder="{{isDetail ? '' : inquiryPlaceHolder}}"
                  rows="5"></textarea>
      </div>
      <ng-container *ngIf="ticket.ticketInfo.status === 'new'; else isDetailBtnTemp">
        <div class="d-flex justify-content-between mb-40px">
          <div>
            <button (click)="cancelTicket()" class="btn btn-outline-dark btn-ticket-create" type="button">Cancel
            </button>
          </div>
          <button (click)="createTicket()" [disabled]="!serviceCenter"
                  class="btn btn-dark btn-ticket-create"
                  type="button">Create
          </button>
        </div>
      </ng-container>
      <ng-template #isDetailBtnTemp>
        <div *ngIf="!isAdminViewerRole">
          <div
            *ngIf="isTicketEditable  && [companies.Seca].includes(company)"
            [ngClass]="{
              'justify-content-between': [companies.Seca].includes(company) && !isDealer && ticket.ticketInfo.processType === 'ZR01' && ticket.ticketInfo.status !== 'E0004',
              'justify-content-end': !([companies.Seca].includes(company) && !isDealer && ticket.ticketInfo.processType === 'ZR01' && ticket.ticketInfo.status !== 'E0004')
              }"
            class="d-flex mb-40px">
            <!--<button class="btn btn-dark btn-ticket-create" type="button"
                    [disabled]="!basic.reason || !basic.status || !scheduleDate"
                    (click)="ticketService.updateTicket()">Update</button>-->
            <button (click)="updateTicket()"
                    *ngIf="[companies.Seca].includes(company) && ticket.ticketInfo.status !== 'E0004'"
                    class="btn btn-outline-black btn-ticket-create" type="button">Update
            </button>
            <button (click)="setRejectReason()"
                    *ngIf="[companies.Seca].includes(company) && !isDealer && ticket.ticketInfo.processType === 'ZR01' && ticket.ticketInfo.status !== 'E0004'"
                    class="btn btn-outline-red btn-ticket-create" type="button">Reject
            </button>
            <button (click)="approve5KTicket()"
                    *ngIf="[companies.Seca].includes(company) && !isDealer && ticket.ticketInfo.processType === 'ZR01' && ticket.ticketInfo.status !== 'E0004'"
                    class="btn btn-outline-blue btn-ticket-create" type="button">Approve
            </button>


          </div>
          <div
            *ngIf="isTicketEditable && [companies.Sea].includes(company)"
            [ngClass]="{
              'justify-content-end': [companies.Sea].includes(company) && !isDealer
              }"
            class="d-flex mb-40px">
            <button (click)="updateTicket()"
                    *ngIf="[companies.Sea].includes(company) && !isDealer"
                    class="btn btn-dark btn-ticket-create" type="button">Update
            </button>
          </div>

          <div
            *ngIf="isTicketEditable && [companies.SeaIm].includes(company)"
            [ngClass]="{
              'justify-content-between': isDraftTicket,
              'justify-content-end': !isDraftTicket
              }"
            class="d-flex mb-40px">
            <!--<button class="btn btn-dark btn-ticket-create" type="button"
                    [disabled]="!basic.reason || !basic.status || !scheduleDate"
                    (click)="ticketService.updateTicket()">Update</button>-->
            <button (click)="cancelDraftTicket()"
                    *ngIf="[companies.SeaIm].includes(company) && isDraftTicket"
                    class="btn btn-outline-red btn-ticket-create" type="button">Delete
            </button>
            <button (click)="goToPayment($event)"
                    *ngIf="isDraftTicket"
                    class="btn btn-dark btn-ticket-create" type="button">Payment
            </button>
            <button (click)="updateTicket()"
                    *ngIf="!isDraftTicket"
                    class="btn btn-dark btn-ticket-create" type="button">Update
            </button>
          </div>
        </div>
      </ng-template>
    </perfect-scrollbar>
  </div>

  <div class="ticket-vertical-line"></div>

  <div class="center-container">
    <div class="service-center-wrapper">
      <div class="l1-title">Service Information</div>

      <perfect-scrollbar [style.padding-right]="'20px'">
        <app-detail-info></app-detail-info>
      </perfect-scrollbar>
    </div>
  </div>

  <div class="ticket-vertical-line"></div>

  <div class="right-container">
    <div class="status-progress">
      <div class="l1-title">Progress</div>
      <div class="py-10px">
        <app-dp-progress (click)="eventService.statusClick($event, ticket.ticketInfo?.processType, ticket.ticketInfo?.detailType, ticket.ticketInfo?.status)" [isFull]="true"
                         [processType]="ticket.ticketInfo?.processType"
                         [status]="(ticket?.ticketInfo?.ticketNo.length === 10 && ticket?.ticketInfo?.ticketNo?.substring(0, 1) !== 'D') ? ticket?.ticketInfo?.status : ''"
                         class="btn-cursor">
        </app-dp-progress>
      </div>
    </div>

    <div class="ticket-horizontal-line"></div>

    <div class="status-progress">
      <div class="l1-title">Additional Attachments</div>
      <ng-container *ngIf="attachmentsList.length > 0; else noAttachment">
        <div class="py-10px attachments-container">
          <div *ngFor="let attachment of attachmentsList" class="attachment-item pointer">
            <div (click)="onClickAttachment(attachment)">
              <ng-container *ngIf="!createThumbnailList(attachment)">
                {{ attachment.filename }}
              </ng-container>
              <img [src]="createThumbnailList(attachment) | secure | async" style="max-width: 100px;"/>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noAttachment>No Attachments</ng-template>

      <div class="col-md-12">
        <div class="text-center">
        </div>
      </div>
    </div>
    <div class="ticket-horizontal-line"></div>

    <div class="conversation">
      <div class="l1-title">Ticket Logs</div>

      <div class="conversation-area">
        <app-conversation></app-conversation>
      </div>

      <div
        *ngIf="ticket.ticketInfo?.status !== 'new' && [companies.Sea].includes(company) && isTicketEditable && !isAdminViewerRole"
        class="comment-area">
        <ng-container>
          <div class="d-flex justify-content-between mt-16px">
            <button (click)="raRequest(this.ticket.ticketInfo)"
                    class="btn btn-outline-dark btn-ticket-conversation"
                    type="button">Request Return Authorization
            </button>
            <button (click)="escalateTicket(this.ticket.ticketInfo)"
                    *ngIf="!(isDealer && doNotAllowComment)"
                    class="btn btn-outline-dark btn-ticket-conversation"
                    type="button">Add Comment
            </button>

          </div>
        </ng-container>
      </div>


    </div>
  </div>
</div>
<!-- FIXME Close Tab Event 발생 시 강제로 실행 -->
<button (click)="deleteComponent()" [hidden]="true" [id]="'close_'+ticketNo">Delete</button>
